var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{class:`btn btn-primary page-action ${_vm.additionalClass}`,attrs:{"to":_vm.url,"disabled":_vm.disabled}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }